import { render } from "./LongSleeve_4_back.vue?vue&type=template&id=836b0f44"
import script from "./LongSleeve_4_back.vue?vue&type=script&lang=js"
export * from "./LongSleeve_4_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__